import { render, staticRenderFns } from "./_language.vue?vue&type=template&id=401105eb&scoped=true&"
import script from "./_language.vue?vue&type=script&lang=js&"
export * from "./_language.vue?vue&type=script&lang=js&"
import style0 from "./_language.vue?vue&type=style&index=0&id=401105eb&prod&scoped=true&lang=css&"
import style1 from "./_language.vue?vue&type=style&index=1&id=401105eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401105eb",
  null
  
)

export default component.exports